<template>
  <div>
    <multiselect
      v-model="selected"
      :multiple="false"
      :options="getQuestionStitcherList"
      :searchable="true"
      :allow-empty="true"
      placeholder="Select Question"
      track-by="name"
      label="name"
      @input="emitSelectedQuestionID"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Multiselect from "vue-multiselect"

export default {
  components: { Multiselect },
  data() {
    return {
      selected: [],
      options: [],
      // // API tag list
      qtags: [],
      // / Component specific tags
      qIds: [],
    }
  },
  computed: {
    ...mapGetters("module", ["getQuestionStitcherList"]),
  },
  mounted() {},
  methods: {
    emitSelectedQuestionID(item) {
      this.$emit("questionIDSelected", { id: item.id })
    },
  },
}
</script>
